import { ReactElement, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import { fetchUniversityList } from 'pages/NewNonEmployee/_api';
import { sortByGroup, sortByLabel } from 'pages/NewNonEmployee/_util';
import StaticAutoComplete from '../base/StaticAutoComplete';

/**
 * Prompt user for input: Universities
 * @param {any} props properties to pass to form field
 * @returns {ReactElement} form field to select a university
 */
const Universities = props => {
	const [originalOptions, setOriginalOptions] = useState([]);
	const [sLoading, setLoading] = useState(true);

	useEffect(() => {
		let active = true;
		async function fetchApi() {
			const response = await fetchUniversityList();
			const processedResponse = response
				.map(u => ({
					value: u.name,
					label: u.name,
					group: null,
				}))
				.sort(sortByLabel)
				.sort(sortByGroup);
			setOriginalOptions(processedResponse);
			setLoading(false);
		}
		if (active) {
			fetchApi();
		}

		return () => {
			active = false;
		};
	}, []);

	return sLoading ? (
		<Skeleton width='100%' />
	) : (
		<StaticAutoComplete originalOptions={originalOptions} {...props} />
	);
};

Universities.propTypes = {
	label: PropTypes.string.isRequired,
	required: PropTypes.string,
	helperText: PropTypes.string,
	name: PropTypes.string.isRequired,
};

export default Universities;
